/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemExchangeRateRespVo } from './SystemExchangeRateRespVo';
import {
    SystemExchangeRateRespVoFromJSON,
    SystemExchangeRateRespVoFromJSONTyped,
    SystemExchangeRateRespVoToJSON,
    SystemExchangeRateRespVoToJSONTyped,
} from './SystemExchangeRateRespVo';

/**
 * 
 * @export
 * @interface PageDataSystemExchangeRateRespVo
 */
export interface PageDataSystemExchangeRateRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataSystemExchangeRateRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataSystemExchangeRateRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataSystemExchangeRateRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<SystemExchangeRateRespVo>}
     * @memberof PageDataSystemExchangeRateRespVo
     */
    records?: Array<SystemExchangeRateRespVo>;
}

/**
 * Check if a given object implements the PageDataSystemExchangeRateRespVo interface.
 */
export function instanceOfPageDataSystemExchangeRateRespVo(value: object): value is PageDataSystemExchangeRateRespVo {
    return true;
}

export function PageDataSystemExchangeRateRespVoFromJSON(json: any): PageDataSystemExchangeRateRespVo {
    return PageDataSystemExchangeRateRespVoFromJSONTyped(json, false);
}

export function PageDataSystemExchangeRateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataSystemExchangeRateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(SystemExchangeRateRespVoFromJSON)),
    };
}

export function PageDataSystemExchangeRateRespVoToJSON(json: any): PageDataSystemExchangeRateRespVo {
    return PageDataSystemExchangeRateRespVoToJSONTyped(json, false);
}

export function PageDataSystemExchangeRateRespVoToJSONTyped(value?: PageDataSystemExchangeRateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(SystemExchangeRateRespVoToJSON)),
    };
}

